/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useRef, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Modal } from '@material-ui/core';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import { trackEvent } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

import RecipientHeader from './Modal/nav/RecipientHeader';
import RecipientNavigationBar from './Modal/nav/RecipientNavigationBar';
import TabPanels from './Modal/body/TabPanels';

const useStyles = makeStyles((theme) => ({
  modal: {
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
  },
  paper: {
   position: "fixed",
   backgroundColor: theme.palette.background.paper,
   boxShadow: theme.shadows[5],
   outline: "none",
   overflow: "auto",
   width: "100%",
   height: '100%',
   left: 0,
   right: 0,
   top: 0,
   bottom: 0,
  },
  underline: {
    textDecoration: 'underline!important',
    fontWeight: 'bold!important',
    color: 'black!important',
    backgroundColor: 'transparent!important',
    border: 'none!important',
    marginRight: '0px!important'
  },
  // Navigation
  appBar: {
   backgroundColor: theme.palette.common.white,
   borderRadius: theme.palette.borderRadius,
   marginBottom: theme.spacing(2),
   color: 'black',
   boxShadow: 'none!important',
   display: 'flex',
   justifyContent: 'space-between',
   alignItems: 'center'
 },
 tabPanel: {
   height: '100%',
   width: '100%'
 },
 tabIndicator: {
   backgroundColor: theme.palette.thankyoucards.underlineColor
 },
 nav: {
   position: 'sticky',
   top: 0,
   zIndex: 1
 },
 fadeHeaderOut: {
   opacity: 0,
   transition: 'opacity 0.2s ease-out'
 },
 fadeHeaderIn: {
   opacity: 1,
   transition: 'opacity 0.2s ease-in'
 },
}));

const RecipientLandingPageController = ({ cardIsleParams, ...props }) => {

  let scrollIntoViewTimer;

  const { productBrand = '' } = props.recipientVerifyData?.ROSSOrder?.[0] || {};
  const isProductBrand18F  = ['1001'].includes(productBrand);

  const classes = useStyles();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [hideHeader, setHideHeader] = useState(false);

  const sectionRefs = [
      useRef(null),
      useRef(null),
      useRef(null),
      useRef(null),
  ];
  const modalRef = useRef(null);

  const component0 = document?.getElementById('section-0')
  const component1 = document?.getElementById('section-1')

  const offsetHeight0 = component0?.offsetHeight || 0;
  const offsetHeight1 = component1?.offsetHeight || 0;
 
   const handleCloseModal = () => {
      dispatch(EventDispatcher.clearRecipientVerifyData());
      setOpen(false);
   };

   const handleChange = (_, index) => {
      setTabValue(index);
      setHideHeader(true);
      clearTimeout(scrollIntoViewTimer);
      scrollIntoViewTimer = setTimeout(() => {
         const section = document?.getElementById(`section-${index}`);
         section?.scrollIntoView({
            behavior: 'smooth',
         });
      }, 300)
   };

   const handleScrollPosition = () => {
      const scrollTop = modalRef.current?.scrollTop;
      if ((scrollTop > offsetHeight0 * 0.8 && tabValue === 0) || (scrollTop < (offsetHeight0 + offsetHeight1 * 0.5) && tabValue === 2)) {
         setTabValue(1)
      } else if (scrollTop > (offsetHeight0 + offsetHeight1 * 0.8) && tabValue === 1) {
         setTabValue(2)
      } else if (scrollTop < (offsetHeight0 * 0.4) && tabValue === 1) {
         setTabValue(0)
      }
   }

   useEffect(() => {
      dispatch(trackEvent({
         eventCategory: 'Test Impression',
         eventAction: 'ThankYouCards',
         eventLabel: `Variant - ${cardIsleParams ? 'CardIsle' : 'NonCardIsle'}`,
         nonInteraction: '1',
      }));

      const handleShowHeader = () => {
         setHideHeader(false);
      };
    
      if (window !== 'undefined') {
        window.addEventListener('touchmove', handleShowHeader, { passive: true }); // Support for iPhones / Safari
        window.addEventListener('wheel', handleShowHeader);
      };
    
      return () => {
         
        if (window !== 'undefined') {
          window.removeEventListener('touchmove', handleShowHeader);
          window.removeEventListener('wheel', handleShowHeader);
        }

        clearTimeout(scrollIntoViewTimer);
      };
   }, []);

   return (
      <Modal
         className={classes.modal}
         open={open}
         onClose={handleCloseModal}
         aria-labelledby="recipient view e-card modal"
         aria-describedby="recipient view e-card modal"
         closeAfterTransition
      >
         <div onScroll={() => handleScrollPosition()} onWheel={() => handleScrollPosition()} className={classes.paper} ref={modalRef} id="recipientmodal">
            <nav className={`${classes.nav} ${hideHeader ? classes.fadeHeaderOut : classes.fadeHeaderIn}`}>
               <RecipientHeader handleCloseModal={handleCloseModal} cardIsleParams={cardIsleParams} brandId={props.brandId} />
               <RecipientNavigationBar handleChange={handleChange} tabValue={tabValue} isProductBrand18F={isProductBrand18F} />
            </nav>
            <TabPanels sectionRefs={sectionRefs} recipientVerifyData={props.recipientVerifyData} cardIsleParams={cardIsleParams} isProductBrand18F={isProductBrand18F} />
         </div>
      </Modal>
   );
};

export default RecipientLandingPageController;
